module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEYSURBVHgBxVJLbsJADLWHj7pMT9B02dJKZFWlbDI3KCeIOEGvkJ6AI7Q3KDeYqaqUZVCh+xwhS9qKGFsQCBCEsuJt7PHYb57tATg3sHDM1/cTYuP9RH4a+J3rcqC58Ug5Qkc5DY48FSBiaMc/r5zzoXt3b7sEaxQX+zDxTEhCIHAQYWjiqat795GCmggeO31QaFGpq0oFp8AtEKvgjrEv59oKZEZ08XepH25HuwSYZ2JMkjiVlQgy5ExmpD0vK8Jbgt+FBaIM5+2hGSduudZ8TmUDzyx9dMhbToxnXR4O/wVyK8RbgsZA+zfpUYJNC/NmF3Isk0xY+gQqO5MikZy3AqgD9W+176WrNVIrQoVhnXqC9gubCM6OJWhkWz3+zk4LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/left-menu-2.png
// module id = 2595
// module chunks = 0